import React, { useState, useEffect } from 'react'
import { string, func, bool, oneOfType, number, shape } from 'prop-types'
import alertIcon from './assets/alert.svg'

const InputBox = ({
  className,
  placeholder,
  type = 'text',
  label,
  value,
  onChange,
  hasWarning,
  warningMsg,
  autoComplete = 'off',
  maxLength,
  handleBlur,
  handleFocus,
  onPasteCapture,
  id,
  transformValue,
  refId,
  validation,
  error,
  containerStyle,
  isPassword,
  hasError,
  errorMsg,
  tabOrder,
  ariaLabel,
  disabled,
  isCurretPasswordTab
}) => {
  const [errorMessage, setErrorMessage] = useState('')
  const onBlur = (e) => {
    handleBlur(e)
    setErrorMessage(validation(value))
  }
  useEffect(() => {
    setErrorMessage('')
  }, [value])

  useEffect(() => {
    isCurretPasswordTab && refId.current.focus()
  }, [isCurretPasswordTab])

  useEffect(() => {
    if (error) return setErrorMessage(error)
    if (hasError) return setErrorMessage(errorMsg)
    return setErrorMessage('')
  }, [error, hasError, errorMsg])
  return (
    <div className={containerStyle ? `${containerStyle} input-box` : 'input-box'}>
      {label && <label htmlFor={id}>{label}</label>}
      <div className={`input-box__wrapper ${disabled && className}`}>
        {!disabled ? (
          <input
            type={type}
            className={`${className} ${errorMessage || hasWarning ? 'error' : ''}`}
            value={transformValue(value)}
            placeholder={placeholder}
            spellCheck="false"
            onChange={onChange}
            autoComplete={autoComplete}
            maxLength={maxLength}
            onBlur={onBlur}
            onFocus={handleFocus}
            onPasteCapture={onPasteCapture}
            id={id}
            ref={refId}
            tabIndex={tabOrder}
            aria-label={!label ? ariaLabel : label}
            disabled={disabled}
          />
      ) : transformValue(value)}

        { errorMessage && !isPassword ? <img src={alertIcon} alt="alert" className="alert" /> : null }
      </div>
      { errorMessage ? <div className="input-error" role="alert">{errorMessage}</div> : null }
      { hasWarning &&
      warningMsg && (
        <div className="input-warning">
          <div className="triangle" />
          {warningMsg}
        </div>
      )}
    </div>
  )
}

InputBox.propTypes = {
  className: string,
  placeholder: string,
  type: string,
  label: string,
  value: oneOfType([string, number]),
  onChange: func,
  autoComplete: string,
  maxLength: string,
  hasWarning: bool,
  warningMsg: string,
  handleBlur: func,
  handleFocus: func,
  onPasteCapture: func,
  id: string,
  transformValue: func,
  refId: shape({}),
  validation: func,
  error: string,
  containerStyle: string,
  isPassword: bool,
  hasError: bool,
  errorMsg: string,
  tabOrder: number,
  ariaLabel: string,
  disabled: bool,
}

InputBox.defaultProps = {
  className: '',
  placeholder: '',
  type: 'text',
  label: '',
  value: '',
  onChange: x => x,
  autoComplete: 'off',
  maxLength: '255',
  hasWarning: false,
  warningMsg: '',
  handleBlur: () => {},
  handleFocus: () => {},
  onPasteCapture: () => {},
  id: null,
  transformValue: val => val,
  refId: null,
  validation: () => '',
  error: '',
  containerStyle: '',
  isPassword: false,
  hasError: false,
  errorMsg: '',
  tabOrder: 0,
  ariaLabel: null,
  disabled: false,
}

export default InputBox
